import { createNavigation } from 'next-intl/navigation'
import locales from './locales'
// The `pathnames` object holds pairs of internal
// and external paths, separated by locale.

export const { Link, redirect, usePathname, useRouter } = createNavigation({
  locales,
})
